if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      
      if (this.classList.contains('added-notification--error')) {
        if (this.isNotifyWhenAvailable()) {
          this.remove();
          return;
        }
        this.setErrorMessage(this.dataset.productTitle);
      } else {
        this.setProductTitle(this.dataset.productTitle);
      }
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    isNotifyWhenAvailable() {
      // Check if the triggering button had "Gelince Haber Ver" text
      const addToCartButton = document.querySelector('button[name="add"]');
      return addToCartButton && addToCartButton.textContent.trim() === 'Gelince Haber Ver';
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    setErrorMessage(message) {
      const messageElement = this.querySelector('.added-notification__message-title');
      const errorMessage = this.querySelector('.added-notification__message-text');
      messageElement.innerText = "Ürün sepete eklenemedi";
      errorMessage.innerText = message;
      messageElement.style.color = '#232323'; 
    }

    display() {
      // reveal
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

      // dismiss after a short period of time
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 6000);

      // add events to internal links
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));
      if (theme.settings.cartType === 'drawer') {
        const cartLinks = this.querySelectorAll('.added-notification__message-text a[href$="/cart"]');
        cartLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
            document.querySelector('.js-cart-drawer').open();
            this.dismiss();
          });
        });
      }
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
